import React, {useCallback, useMemo, useRef} from "react";
import TileLayer from "ol/layer/Tile";
import {GetShippingAPIParams2,} from "../../../api/apiTypes";
import {XYZ} from "ol/source";
import {Layout} from "antd";
import './shippingScreen.css';
import {Coordinate} from "ol/coordinate";
import ShippingMap from "../../organisms/shippingMap/ShippingMap";
import {useSearchParams} from "react-router-dom";
import {extractExistingParams} from "../../../common/fns";
import {ShippingFilter} from "../../organisms/shippingMap/ShippingFilter";

export type SectorColorType = {
  sector?: string;
  color: string;
};

export type HoveredShippingTooltipType<T> = {
  shippings?: T[];
  position?: Coordinate;
};

const ShippingMapScreen = () => {
  const mapRef = useRef<any>();
  const filterRef = useRef<any>();
  const [searchParams] = useSearchParams();
  
  const handleResetSelectedShippings = useCallback(() => {
    if (mapRef.current) mapRef.current.reset();
    if (filterRef.current) filterRef.current.setShippings([]);
  }, []);
  
  const params: GetShippingAPIParams2 = useMemo(() => {
    handleResetSelectedShippings();
    return extractExistingParams(searchParams);
  }, [handleResetSelectedShippings, searchParams]);
  
  const handleSelectShippings = useCallback((selectedShippings) => {
    if (filterRef.current) filterRef.current.setShippings(selectedShippings);
  }, []);
  
  return (<Layout className={"container-p5 shipping"}>
    <ShippingFilter ref={filterRef} params={params}
                    onResetShipping={handleResetSelectedShippings} />
    <ShippingMap
      ref={mapRef}
      params={params}
      onSelectShippings={handleSelectShippings}
    />
  </Layout>);
};

export default ShippingMapScreen;
